import React, {useEffect, useState} from "react";
import db from "../../../../services/query";
import ResultTable from "./_ResultTable";
import ResultStudentInfoHeader from "./_ResultStudentInfoHeader";
import ResultSignatureArea from "./_ResultSignatureArea";
import ResultClassInfo from "./_ResultClassInfo";

const ClassResultBook = (props) => {

    const [data, updateData] = useState({});

    useEffect(async () => {

        const ac = new AbortController();

        requestData();
        return () => ac.abort();
    }, []);

    const requestData = async () => {
        const {classId} = props.match.params;

        await db.getAll(`results/resultBook/${classId}`).then(({data}) => {
            // making each subjects array exactly 12 rows.(with extra empty rows)
            data?.data?.forEach((student, index) => {
                let rowCount = student?.subjects[0]?.length;

                if (rowCount < 12) {
                    let emptyRow = {};
                    const keys = Object.keys(student?.subjects[0][0] ?? {});
                    keys.forEach(key => emptyRow[key] = '')

                    while (rowCount++ < 12) student?.subjects[0]?.push(emptyRow)
                }
            });
            updateData(data);
        });
    };

    const students = data?.data || [];
    const pages = [];
    for (let i = 0; i < students.length; i += 2) {
        pages.push(students.slice(i, i + 2));
    }

    const renderStudentCard = (student, absoluteIndex) => (
        <div
            key={student.student_id}
            className="white-background-with-border student-result-card"
            style={{
                padding: "5px",
                margin: "5px",
                border: "2px solid grey",
                display: "flex",
                flexDirection: "column",
                gap: "5px",
            }}
        >
            <ResultStudentInfoHeader student={student} counter={absoluteIndex + 1}/>

            <hr style={{
                border: "none",
                background: "#c1c1c1",
                height: "2px",
            }}/>

            <div className="result-tables-row" style={{
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                flex: 1,
                minHeight: 0,
            }}
            >
                <ResultTable student={student} counter={1}/>
                <ResultTable student={student} counter={5}/>
                <ResultTable student={student} counter={9}/>
            </div>
        </div>
    );

    return (
        <main className={`main-print-wrapper class-result-book`}>
            <div id="table-container">
                {pages.map((pageStudents, pageIndex) => (
                    <section
                        key={`result-page-${pageIndex}`}
                        className={`result-print-page${pageIndex === 0 ? " result-print-page--first" : ""}`}
                    >
                        {pageIndex === 0 && (
                            <>
                                <div className="print-header class-result-book-header">
                                    <div style={{textAlign: "center", width: "100%"}}>
                                        <p>وزارت تحصیلات عالی</p>
                                        <p>معاونیت امورمحصلان</p>
                                    </div>
                                </div>
                                <ResultClassInfo class_info={data?.summary?.class_info}/>
                            </>
                        )}

                        <div className="result-print-page-students">
                            {pageStudents.map((student, localIndex) =>
                                renderStudentCard(student, pageIndex * 2 + localIndex)
                            )}
                        </div>
                    </section>
                ))}
            </div>

            <ResultSignatureArea class_info={data?.summary?.class_info}/>
        </main>
    );
};

export default ClassResultBook;
